import { format as dateFnsFormat } from 'date-fns'

export const BUSINESS_TIME_ZONE = 'Australia/Sydney'

const partsFormatter = new Intl.DateTimeFormat('en-AU', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23',
})

const partsFor = value => Object.fromEntries(
    partsFormatter.formatToParts(value instanceof Date ? value : new Date(value))
        .filter(part => part.type !== 'literal')
        .map(part => [part.type, Number(part.value)])
)

// A Date used only as a carrier for Sydney wall-clock fields in local date pickers.
export const toBusinessWallDate = value => {
    if (value === null || value === undefined || value === '') return null
    const date = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(date.getTime())) return null
    const part = partsFor(date)
    return new Date(part.year, part.month - 1, part.day, part.hour, part.minute, part.second, date.getMilliseconds())
}

export const formatBusinessDate = (value, pattern = 'd MMM yyyy', options = {}) => {
    const wallDate = toBusinessWallDate(value)
    return wallDate ? dateFnsFormat(wallDate, pattern, options) : ''
}

// Treat local picker fields as Sydney time, then persist the corresponding UTC instant.
export const businessWallDateToDate = value => {
    if (value === null || value === undefined || value === '') return null
    const wall = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(wall.getTime())) return null
    const desiredUtc = Date.UTC(
        wall.getFullYear(), wall.getMonth(), wall.getDate(),
        wall.getHours(), wall.getMinutes(), wall.getSeconds(), wall.getMilliseconds()
    )
    let candidate = new Date(desiredUtc)
    for (let index = 0; index < 2; index += 1) {
        const part = partsFor(candidate)
        const representedUtc = Date.UTC(part.year, part.month - 1, part.day, part.hour, part.minute, part.second, candidate.getMilliseconds())
        candidate = new Date(candidate.getTime() + desiredUtc - representedUtc)
    }
    return candidate
}

export const businessWallDateToIso = value => businessWallDateToDate(value)?.toISOString() || ''
